<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6">
          <div class="text-h5 font-weight-bold">月經史</div>
          <div class="mt-6">
            <div class="d-flex align-center mb-2 is-input">
              <div class="font-weight-bold label-width">初經年齡</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.初經年齡"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入年齡"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div class="d-flex align-center mb-0 is-radio">
              <div class="font-weight-bold label-width flex-shrink-0">
                是否已經停經
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.是否已經停經"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否', '不知道']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="問卷.是否已經停經 == '否' || 問卷.是否已經停經 == '不知道'"
            >
              <div class="font-weight-bold label-width">最近一次月經日期</div>
              <div class="">
                <v-text-field
                  class=""
                  v-model="問卷.最後一次月經日期"
                  :rules="[
                    (v) =>
                      !!v || '此為必填欄位，例:民國111年3月22日請填寫1110322',
                  ]"
                  label="請輸入日期"
                  outlined
                  dense
                  persistent-hint
                  hint="例:民國111年3月22日請填寫1110322"
                ></v-text-field>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="問卷.是否已經停經 == '否' || 問卷.是否已經停經 == '不知道'"
            >
              <div class="font-weight-bold label-width">
                非月經期間是否有不正常陰道出血及異常分泌物
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.非月經異常分泌物"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否', '不知道']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="問卷.是否已經停經 == '是'"
            >
              <div class="font-weight-bold label-width">停經年齡</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.停經年齡"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入年齡"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div
              class="d-flex align-center is-radio"
              v-if="問卷.是否已經停經 == '是'"
            >
              <div class="font-weight-bold label-width flex-shrink-0">
                停經原因
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.停經原因"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['自然停經', '子宮切除', '卵巢切除', '其他']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="text-h5 font-weight-bold">生產史</div>
          <div class="mt-6">
            <div class="d-flex align-center mb-2 is-input">
              <div class="font-weight-bold label-width">生產次數</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.生產次數"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入次數"
                  outlined
                  dense
                  persistent-hint
                  hint="如無生產經驗請填 0"
                ></v-text-field>
              </div>
            </div>
            <div class="d-flex align-center mb-2 is-radio">
              <div class="font-weight-bold label-width">曾餵母乳一個月以上</div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.曾餵母乳一個月以上"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div class="d-flex align-center mb-2 is-input">
              <div class="font-weight-bold label-width">第一胎生產實足年齡</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.第一胎生產實足年齡"
                  label="請輸入年齡"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div class="d-flex align-center mb-2 is-radio">
              <div class="font-weight-bold label-width">是否服用口服避孕藥</div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.是否服用口服避孕藥"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="問卷.是否服用口服避孕藥 == '是'"
            >
              <div class="font-weight-bold label-width">幾歲開始口服避孕藥</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.幾歲開始口服避孕藥"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入年齡"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="問卷.是否服用口服避孕藥 == '是'"
            >
              <div class="font-weight-bold label-width">服用口服避孕藥年限</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.服用口服避孕藥年限"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入幾年"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <div class="text-h5 font-weight-bold">子宮史</div>
          <div class="mt-6">
            <div class="d-flex align-center mb-1 is-radio">
              <div class="font-weight-bold label-width flex-shrink-0">
                子宮是否切除
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.子宮是否切除"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div class="d-flex align-center mb-1 is-radio">
              <div class="font-weight-bold label-width flex-shrink-0">
                子宮是否受過放射治療
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.子宮是否受過放射治療"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否', '不知道']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div class="d-flex align-center mb-1 is-radio">
              <div class="font-weight-bold label-width flex-shrink-0">
                接種過乳突病毒疫苗
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.接種過乳突病毒疫苗"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div class="d-flex align-center mb-1 is-radio">
              <div class="font-weight-bold label-width flex-shrink-0">
                做過乳突病毒檢測
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.做過乳突病毒檢測"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否', '不知道']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="text-h5 font-weight-bold">其他</div>
          <div class="mt-6">
            <div class="d-flex align-center mb-2 is-radio" v-if="年齡 <= 70">
              <div class="font-weight-bold label-width flex-shrink-0">
                是否服用賀爾蒙
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.是否服用賀爾蒙"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="年齡 <= 70 && 問卷.是否服用賀爾蒙 == '是'"
            >
              <div class="font-weight-bold label-width">幾歲開始服用賀爾蒙</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.開始服用賀爾蒙年齡"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入年齡"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div
              class="d-flex align-center mb-2 is-input"
              v-if="年齡 <= 70 && 問卷.是否服用賀爾蒙 == '是'"
            >
              <div class="font-weight-bold label-width">服用賀爾蒙年限</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.服用賀爾蒙年限"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入幾年"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div
              class="d-flex align-center mb-1 is-input"
              v-if="年齡 <= 70 && 問卷.是否服用賀爾蒙 == '是'"
            >
              <div class="font-weight-bold label-width">服用賀爾蒙原因</div>
              <div class="">
                <v-text-field
                  class="input-width"
                  v-model="問卷.服用賀爾蒙原因"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  label="請輸入原因"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div class="d-flex align-center mb-1 is-radio">
              <div class="font-weight-bold label-width flex-shrink-0">
                用力咳嗽是否漏尿
              </div>
              <div class="">
                <v-radio-group
                  class=""
                  v-model="問卷.用力咳嗽是否漏尿"
                  :rules="[(v) => !!v || '此為必填欄位']"
                  row
                >
                  <v-radio
                    class="mr-6"
                    v-for="key in ['是', '否']"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "QuestionContent",
  props: ["valid", "person", "問卷"],
  data: () => ({}),
  computed: {
    年齡() {
      let birth = parseInt(this.person.出生年月日) + 19110000 + "";
      return dayjs().year() - dayjs(birth).year();
    },
  },
};
</script>
<style lang="scss" scoped>
.label-width {
  width: 165px;
}
.input-width {
  width: 130px;
  ::v-deep .v-input__slot {
    margin: 0;
    padding: 0;
    min-height: 32px !important;
  }
  ::v-deep input {
    margin: 0;
    padding: 0;
  }
  ::v-deep .v-label {
    top: 6px !important;
    font-size: 0.875rem;
  }
}
.v-input--selection-controls {
  padding-top: 0px;
}
::v-deep .v-input--radio-group {
  position: relative;
  top: 5px;
  margin-top: 0px;
  .v-input__slot {
    margin-bottom: 2px;
  }
}
</style>
